import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-sm-6" }
const _hoisted_2 = {
  class: "float-start position-absolute z-index-1",
  style: {}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-2 text-white" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-2 text-white" }, null, -1)
const _hoisted_5 = { class: "ribbon" }
const _hoisted_6 = { class: "row g-0" }
const _hoisted_7 = { class: "col-md-5" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-md-7" }
const _hoisted_10 = { class: "d-flex flex-column h-100 pt-8" }
const _hoisted_11 = { class: "title d-flex align-items-center flex-grow-1 px-8" }
const _hoisted_12 = { class: "h3 text-fprimary m-0" }
const _hoisted_13 = { class: "card-text d-flex flex-column px-8" }
const _hoisted_14 = { class: "d-flex flex-row align-items-center mb-4 w-100" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = { class: "fw-bolder" }
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "d-flex flex-row align-items-center w-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-week fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_21 = { class: "d-flex flex-column" }
const _hoisted_22 = { class: "fw-bolder" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "d-flex flex-row align-items-center w-100" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_26 = { class: "d-flex flex-column" }
const _hoisted_27 = { class: "fw-bolder" }
const _hoisted_28 = { class: "d-flex justify-content-center pt-5 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.onDelete)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "shadow",
            size: "large",
            type: "danger",
            circle: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('on-delete-action', _ctx.evento)), ["stop"]))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.onEdit)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            class: "shadow",
            size: "large",
            type: "primary",
            circle: "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('on-edit-action', _ctx.evento)), ["stop"]))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_link, {
      to: _ctx.to,
      class: _normalizeClass(["card mb-5 shadow text-black border border-2 border-secondary border-hover-fprimary", _ctx.onDelete ? 'mt-4 ms-4' : ''])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(`bg-${_ctx.evento?.status_params}`)
          }, _toDisplayString(_ctx.evento?.status_name), 3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_image, {
              class: "w-100 h-300px d-none d-md-block d-lg-block",
              src: _ctx.evento?.logo,
              fit: 'contain',
              style: _normalizeStyle({ filter: _ctx.evento?.mstatus == 2 ? 'grayscale(100%)' : 'none' })
            }, {
              error: _withCtx(() => [
                _createElementVNode("img", {
                  class: "",
                  src: _ctx.myCompany?.avatar_vertical,
                  style: {"width":"100%","height":"100%","object-fit":"contain"}
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }, 8, ["src", "style"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.evento?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t("place")), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.evento?.place), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t("date")), 1),
                      _createElementVNode("span", {
                        innerHTML: _ctx.getDate(_ctx.evento?.startdate, _ctx.evento?.enddate)
                      }, null, 8, _hoisted_23)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t("modality")), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.evento?.modality == 'V' ? 'Virtual' : 'Presencial'), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_router_link, {
                  to: _ctx.to,
                  class: "btn btn-info btn-sm text-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("details")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["to", "class"])
  ]))
}